import { TeachersView } from "../components/principal/TeachersView";

export const Teachers: React.FC = () => {
  return (
    <div>
      <TeachersView />
    </div>
  );
};
